export default __webpack_public_path__ + "static/media/02.ce979421.svg";